export default {
  id: 222,
  title: 'Target #222 - Rocket',
  url: 'https://cssbattle.dev/play/222',
  colors: ['#B0E1FB', '#C15965', '#4B4D88'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{left:135;border-style:solid;border-width:0 65px 60px}body{background:#b0e1fb}p{position:fixed;margin:0}p[a]{bottom:130;border-color:#4b4d88 #b0e1fb}p[b]{bottom:40;border-color:#c15965 #b0e1fb}p[c]{top:40;left:165;width:50;height:180;background:#4b4d88;border:10px solid #b0e1fb;border-radius:1in',
}
